var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavouriteOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3,16c-0.2,0-0.3-0.1-0.4-0.1c-0.1-0.1-0.3-0.3-0.2-0.7l0-0.2c0.3-1.4,0.7-2.8,1.1-4.4c0-0.1,0-0.4-0.1-0.5 C2.1,8.7,0.9,7.4,0.2,6.5C0,6.3,0,6,0,5.8c0.1-0.2,0.3-0.4,0.6-0.5C1.9,5.1,3.3,4.9,5,4.7c0.1,0,0.3-0.2,0.4-0.3 c0.7-1.5,1.4-2.9,2-4C7.5,0.2,7.7,0,8,0c0.3,0,0.5,0.2,0.6,0.4c0.6,1.1,1.3,2.5,2,4c0.1,0.1,0.3,0.3,0.4,0.3 c1.6,0.2,3.1,0.4,4.4,0.6c0.3,0.1,0.5,0.2,0.6,0.5C16,6,16,6.3,15.8,6.5c-0.7,0.9-1.9,2.2-3.2,3.6c-0.1,0.1-0.2,0.3-0.1,0.5 c0.4,1.6,0.8,3.1,1.1,4.5c0.1,0.5-0.1,0.7-0.2,0.8c-0.1,0.1-0.4,0.2-0.8,0c-0.6-0.4-1.2-0.8-1.9-1.2c-0.8-0.5-1.6-1-2.5-1.5l0,0 c-0.1-0.1-0.3-0.1-0.4,0c-0.9,0.5-1.7,1.1-2.5,1.5c-0.6,0.4-1.3,0.8-1.9,1.2C3.3,16,3.1,16,3,16z M8.7,12.3c0.9,0.5,1.7,1,2.5,1.5 c0.4,0.3,0.9,0.5,1.3,0.8c-0.3-1.2-0.6-2.5-0.9-3.8c-0.1-0.4,0-1,0.4-1.4c1.1-1.2,2.2-2.4,2.9-3.3c-1.1-0.2-2.5-0.4-3.9-0.5 c-0.5-0.1-1-0.4-1.2-0.8C9.1,3.5,8.5,2.3,8,1.3c-0.5,1-1.1,2.2-1.7,3.5C6.1,5.3,5.6,5.6,5.1,5.7C3.7,5.8,2.3,6,1.2,6.2 c0.7,0.9,1.7,2,2.9,3.3c0.3,0.3,0.5,0.9,0.4,1.4c-0.3,1.3-0.6,2.6-0.9,3.8c0.4-0.3,0.9-0.5,1.3-0.8c0.8-0.5,1.6-1,2.4-1.5 C7.7,12,8.3,12,8.7,12.3L8.7,12.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavouriteOutline);
export default __webpack_public_path__ + "static/media/favourite-outline.3ee905f0db7ab25ece0150a91223a8a0.svg";
export { ForwardRef as ReactComponent };